/**
 * Constants for Polygon/ROI Component
 */

// Action Types
export const ACTION_TYPES = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
  ALERT_UPDATE: "AlertUpdate",
  EDIT: "Edit"
};

// Location Types
export const LOCATION_TYPES = {
  CVAPP: "cvapp"
};

// CV App Names
export const CVAPP = {
  OBJECT_BLUR: "objectblur",
  CAMERA_ADJUSTMENT: "cameraadjustment",
  PEOPLE_COUNT_EE: "peoplecountee",
  VEHICLE_COUNT_EE: "vehiclecountee",
  PARKING_OCCUPANCY_EE: "parkingoccupancyee",
  PARKING_OCCUPANCY_EE_FULLNAME: "parkingoccupancyeefullname",
  PEOPLE_COUNT_EE_FULLNAME: "peoplecounteefullname",
  VEHICLE_COUNT_EE_FULLNAME: "vehiclecountetreefullname"
};

// Radio Box Options
export const RADIO_BOX_OPTIONS = {
  FULL_SCREEN: "full-screen",
  CUSTOM_AREA: "custom-area",
  PREVIOUSLY_DEFINED: "previously-defined"
};

// Radio Group Default Configuration
export const RADIO_GROUP_CONFIG = {
  FULL_SCREEN: {
    id: "full-screen",
    value: "full-screen",
    text: "Full screen",
    type: "radiobox",
    subtext: "Run selected app on entire stream"
  },
  CUSTOM_AREA: {
    id: "custom-area",
    value: "custom-area",
    text: "Custom area",
    type: "radiobox",
    subtext: "Draw a custom area in which to run selected app"
  },
  PREVIOUSLY_DEFINED: {
    id: "previously-defined",
    value: "previously-defined",
    text: "Previously defined",
    type: "radiobox",
    width: "269px",
    subtext: "Select from previously defined regions of interest (below)"
  }
};

// Notification Messages
export const NOTIFICATION_MESSAGES = {
  SNAPSHOT_FAIL: "Snapshot Fail",
  ROI_CREATE_FAIL: "ROI Create Fail",
  ROI_CREATE_FAIL_MESSAGE: "Failed to create the ROI. Please try again later",
  ROI_DEPLOY_FAIL_MESSAGE: "Failed to Deploy the ROI. Please try again later",
  ROI_UPDATE_FAIL_MESSAGE: "Failed to update the ROI. Please try again later",
  ROI_REFRESH_FAIL_MESSAGE: "Failed to refresh ROI list",
  ALERT_DELETED: "Alert deleted",
  ALERT_DELETED_MESSAGE: "Alert deleted successfully",
  ALERT_SUBMITTED: "Alert has been submitted successfully."
};

// Notification Types
export const NOTIFICATION_TYPES = {
  SNAPSHOT_FAIL: "Snapshot Fail",
  ROI_CREATE_FAIL: "ROI Create Fail",
  ROI_UPDATE_FAIL: "ROI Update Fail",
  ALERT_DELETED: "Alert deleted"
};

// Notification Priorities
export const NOTIFICATION_PRIORITIES = {
  SUCCESS: "success",
  CRITICAL: "critical"
};

// Zone Types
export const ZONE_TYPES = {
  ZONE1: "Zone1",
  ZONE2: "Zone2"
};

// Zone Labels
export const ZONE_LABELS = {
  ZONE_1: "Zone 1",
  ZONE_2: "Zone 2"
};

// Default Colors
export const DEFAULT_COLORS = {
  ZONE1: "red",
  ZONE2: "#0089ECB2",
  NO_ZONE: "#6F7171CC",
  LINE: "#ffffff"
};

// Polygon Style Defaults
export const POLYGON_STYLE = {
  LINE_COLOR: "#9B0606",
  FILL_COLOR: "#c51b1b80",
  VERTEX_COLOR: "#ff0000",
  VERTEX_RADIUS: 6,
  VERTEX_STROKE_WIDTH: 2
};

// Image Size
export const IMAGE_SIZE = {
  width: 100,
  height: 65
};

// Original Image Size
export const ORIGINAL_IMAGE_SIZE = [832, 532];

// Text Defaults
export const TEXT_DEFAULTS = [
  {
    x: 450,
    y: 200,
    width: 55,
    height: 15,
    text: "Zone 1",
    fontSize: 16,
    fill: "white",
    id: "text1"
  },
  {
    x: 450,
    y: 300,
    width: 55,
    height: 15,
    text: "Zone 2",
    fontSize: 16,
    fill: "white",
    id: "text2"
  }
];

// Rectangle Defaults
export const RECTANGLE_DEFAULTS = [
  {
    x: 285,
    y: 239,
    width: 377,
    height: 40,
    fill: "rgba(255,0,0)",
    id: "rect1"
  }
];

// Circle Defaults
export const CIRCLE_DEFAULTS = [
  {
    x: 474,
    y: 259,
    radiusX: 189,
    radiusY: 89,
    fill: "rgba(255,255,255,0.5)",
    id: "circle1"
  }
];

// Config Keys
export const CONFIG_KEYS = {
  DEPLOY_PARAMETERS: "deploy-parameters"
};

// Filter Options
export const FILTER_OPTIONS = {
  EXPAND: "$expand",
  SELECTION: "$selection",
  EXPAND_VALUE: "fields,cvapp"
};

// Session Storage Keys
export const SESSION_STORAGE_KEYS = {
  CV_APP_LIST: "cvAppList",
  POLYGONS_POINTS: "polygonsPoints"
};

// Default Values
export const DEFAULT_VALUES = {
  USERNAME: "service",
  PASSWORD: null,
  MAX_POLYGONS: 1,
  RADIO_WIDTH_WITH_ROIS: "269px",
  RADIO_WIDTH_WITHOUT_ROIS: "410px",
  TAG_VALUE_ALL: "-1"
};

// Deployment Status
export const DEPLOYMENT_STATUS = {
  DEPLOYING: "deploying",
  DEPLOYED: "deployed"
};

// Stream Types
export const STREAM_TYPES = {
  PAIRED_CAMERA: "PAIRED_CAMERA"
};

// ROI Label Template
export const ROI_LABEL_TEMPLATE = (polygonCount, group, appName) => 
  `ROI${polygonCount}-${group}-${appName}`;

// Permission Types
export const PERMISSION_TYPES = {
  ALERTS: "Alerts",
  CREATE: "Create",
  NO_PERMISSION: "No Permission"
};

// Form Resource Types
export const FORM_RESOURCE_TYPES = {
  ADVANCED_PARAMETERS_FORM: "advancedparameters-form",
  ADVANCED_PARAMETERS: "advancedparameters",
  STANDARD_PARAMETERS_FORM: "standarparameters-form",
  STANDARD_PARAMETERS: "standarparameters"
};

// Timeout Durations (in milliseconds)
export const TIMEOUT_DURATIONS = {
  MODAL_OPEN: 50,
  RULE_MODAL_OPEN: 100,
  CLEAR_ROI: 1000,
  DELETE_STATE: 100,
  ROI_RESPONSE_CHECK: 3000,
  SUBMITTED: 1000
};

// API Response Keys
export const API_RESPONSE_KEYS = {
  ERROR: "error",
  ERROR_DESCRIPTION: "error_description",
  ID: "id",
  DEVICE_ID: "deviceid",
  DEPLOYMENT_ID: "deploymentid",
  STATUS: "status",
  CUSTOM_DATA: "customdata",
  POLYGON: "polygon"
};

// Category Types
export const CATEGORY_TYPES = {
  STATISTICS_APPS: "Statistics Apps"
};

// Action From Types
export const ACTION_FROM_TYPES = {
  CAMERA_PAIRING: "cameraPairing"
};

// Route Paths
export const ROUTE_PATHS = {
  DEVICES: "/devices"
};

// Initial Data Template
export const getInitialData = (roiLabel, cvappGroup, cvAppName) => [
  {
    id: "d3ab238e-c2fd-4337-a397-3d813f575894",
    label: roiLabel,
    points: [
      [1.2734375, 2.453125],
      [829.2734375, 1.453125],
      [830.2734375, 528.453125],
      [0.2734375, 529.453125]
    ],
    vertexRadius: 1,
    lineColor: DEFAULT_COLORS.ZONE1,
    fillColor: POLYGON_STYLE.FILL_COLOR,
    vertexColor: POLYGON_STYLE.VERTEX_COLOR,
    vertexStrokeWidth: POLYGON_STYLE.VERTEX_STROKE_WIDTH,
    groupName: cvappGroup,
    cvAppName: cvAppName
  }
];

// Button Labels
export const BUTTON_LABELS = {
  FINISH: "Finish",
  SKIP_TO_NEXT_ROI: "Skip to next ROI",
  SKIP_TO_NEXT_APP: "Skip to next app",
  SAVE: "Save",
  SUBMIT: "Submit",
  EDIT_NEXT: "Edit next"
};

// Error Messages
export const ERROR_MESSAGES = {
  FETCH_DATA_ERROR: "Error fetching data",
  DOWNLOAD_IMAGE_ERROR: "Error downloading image:",
  IMAGE_DOWNLOAD_ERROR: "Image download Error"
};

export const FULL_SCREEN_ONLY = "This app runs on the full screen only. The region of interest cannot be edited.";
export const POLYGON_EXCEEDING_BOUNDARY = "Polygon or part of polygon exceeding image boundary. Please fix it.";